import React, { Component } from "react";
import axios from "axios";
import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Serverurl from "./Apiurl";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
export default class MaterialZeroAmountEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
     
      projectId: "",
      projects: [],mpAmounts: {},
  displayUnits: {},
	     projectarray: [], 
  pendingUnits: {},
  projectarrauto: [],
  selectedProject: null,
      page: 0,
      rowsPerPage: 10,
      totalRecords: 0,
      loading: false
    };
  }
  componentWillMount() {
	  
	   if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Material Purchases Report";   
			 this.props.parentsCallback(
           strname
        );

    this.fetchZeroAmount();
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleClickSearch= (event) => {
	  
	this.fetchZeroAmount();  
	  
  }
  fetchZeroAmount = (e) => {
    if (e) e.preventDefault();
    this.setState({ loading: true });
  axios.get(
  Serverurl +
    "ajaxmaterialprocurement.php?action=getzeroamount" +
    "&projectid=" + this.state.projectId + "&sorting=mp_id desc"
)
      .then((res) => {
        this.setState({
          data: res.data || [],
          totalRecords: res.data?.[0]?.count || 0,
          mpAmounts: {},
          loading: false
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  handleAmountChange = (id, value) => {
    this.setState((prev) => ({
      mpAmounts: {
        ...prev.mpAmounts,
        [id]: value
      }
    }));
  };
submitAmounts = () => {

  let temp = [];

  this.state.data.forEach((row) => {

    const amount =
      this.state.mpAmounts[row.mp_id] ?? 0;

    const unit =
      this.state.displayUnits[row.mp_id] ??
      row.mp_units;

    temp.push(
      `${row.mp_id}~${amount}~${unit}`
    );

  });

  const mp_data = temp.join("`");



  if (mp_data === "") {
    alert("No data found");
    return;
  }

  let formData = new FormData();

  formData.append(
    "action",
    "updatematerialamount"
  );

  formData.append(
    "mp_data",
    mp_data
  );

  formData.append(
    "userid",
    localStorage.getItem("VRuserid")
  );

  axios
    .post(
      Serverurl + "ajaxmaterialprocurement.php",
      formData
    )
    .then((res) => {

      alert("Updated Successfully");

      this.fetchZeroAmount();

    })
    .catch((err) => {

      console.log(err);

      alert("Error while saving");

    });

};
  handlePageChange = (event, newPage) => {
    this.setState({ page: newPage }, () => this.fetchZeroAmount());
  };
handleUnitChange = (id, unit) => {
  this.setState((prev) => ({
    pendingUnits: {
      ...prev.pendingUnits,
      [id]: unit
    }
  }));
};
updateQuantityUnit = (id) => {
  this.setState((prev) => ({
    displayUnits: {
      ...prev.displayUnits,
      [id]: prev.pendingUnits[id]
    }
  }));
};
  handleRowsChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      () => this.fetchZeroAmount()
    );
  };
  /*project autoextender*/
onloadProjectBind = (event) => {
axios.get(
  Serverurl +
    "ajaxprojects.php?action=getallprojectautoextender" +
    "&projectname=" + encodeURIComponent(event.target.value)
)
    .then((resp) => {
      let strCust = [];
      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };
        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );
        if (!found) {
          strCust.push(item);
        }
      });
      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};
onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};
getUnitName = (unitId) => {
  switch (Number(unitId)) {
    case 1:
      return "KG";
    case 2:
      return "TON";
    case 3:
      return "BAG";
    case 4:
      return "CFT";
    case 5:
      return "M3";
	   case 6:
      return "SQFT";
	   case 7:
      return "MTR";
	   case 8:
      return "Running Feet";
	   case 9:
      return "NOS";
	   case 10:
      return "LTR";
	  case 11:
      return "Bundle";
	  case 12:
      return "Sheet";
    default:
      return "";
  }
};
  render() {
  return (
      <React.Fragment>
              
              
                       

                        <div className="searchmaster">
                            <ul>
                            
                                <li>
             
            <p>Project</p>
<p>
            <Autocomplete className="inputcntlparent"
              options={this.state.projectarrauto}
              value={this.state.selectedProject}
              onChange={this.onProjectChange}
              getOptionLabel={(option) => option.title || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Search Project"
                  onChange={this.onloadProjectBind}
                />
              )}
              renderOption={(props, option) => (
                <p {...props}>
                  {option.title}
                </p>
              )}
              fullWidth
            />
          </p></li>

          <li>
		  <p>&nbsp;</p>
		  <p>
            <Button
              type="submit"
              variant="contained"
       onClick={this.handleClickSearch} endIcon={<SearchIcon />}
            >
              Search
            </Button>
        </p>  </li></ul>
        </div>
		{this.state.data.length>0 && (
  <React.Fragment>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Project</TableCell>
                <TableCell>Vendor</TableCell>
                <TableCell>Material</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {this.state.data.map((row) => (
                <TableRow key={row.mp_id}>
                  <TableCell>
                    {row.pj_projectname}
                  </TableCell>

                  <TableCell>
                    {row.vm_vendorname}
                  </TableCell>

                  <TableCell>
                    {row.mp_material}
                  </TableCell>
<TableCell>
  {row.mp_quantity}{" "}
  {
    this.getUnitName(
      this.state.displayUnits[row.mp_id] ??
      row.mp_units
    )
  }
</TableCell>
<TableCell>
  <div className="amountContainer">

    {/* Amount Section */}
    <div className="amountBlock">

      <TextField
        size="small"
        className="amountTextbox"
        value={this.state.mpAmounts[row.mp_id] ?? 0}
        onChange={(e) =>
          this.handleAmountChange(
            row.mp_id,
            e.target.value
          )
        }
      />

      <div className="suggestedAmountSection">

        <span className="suggestedAmount">
          {row.suggested_amount}
        </span>

        {row.suggested_amount !== null &&
          row.suggested_amount !== undefined &&
          row.suggested_amount !== "" && (
            <span
              className="updateLink"
              onClick={() =>
                this.handleAmountChange(
                  row.mp_id,
                  row.suggested_amount
                )
              }
            >
              Update
            </span>
          )}

      </div>

    </div>

    {/* Unit Section */}
    <div className="unitBlock">

      <FormControl
        size="small"
        className="unitDropdown"
      >
        <Select
          value={
            this.state.pendingUnits?.[row.mp_id] ??
            this.state.displayUnits[row.mp_id] ??
            row.mp_units
          }
          onChange={(e) =>
            this.handleUnitChange(
              row.mp_id,
              e.target.value
            )
          }
        >
          <MenuItem value={1}>Kgs</MenuItem>
          <MenuItem value={2}>TON</MenuItem>
          <MenuItem value={3}>BAG</MenuItem>
          <MenuItem value={4}>CFT</MenuItem>
          <MenuItem value={5}>M3</MenuItem>
		   <MenuItem value={6}>SQFT</MenuItem>
          <MenuItem value={7}>MTR</MenuItem>
          <MenuItem value={8}>Running Feet</MenuItem>
          <MenuItem value={9}>NOS</MenuItem>
          <MenuItem value={10}>LTR</MenuItem>
		   <MenuItem value={11}>Bundle</MenuItem>
          <MenuItem value={12}>Sheet</MenuItem>
        
        </Select>
      </FormControl>

      <span
        className="updateLink"
        onClick={() =>
          this.updateQuantityUnit(row.mp_id)
        }
      >
        Update
      </span>

    </div>

  </div>
</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="aligncenter">
          <Button
            variant="contained"
            onClick={this.submitAmounts}
          >
            Submit
          </Button>
        </div>
     </React.Fragment>
		)}
    </React.Fragment>
  );
}
}
